module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc-container"
  }, [_c('div', {
    staticClass: "desc-inner-container"
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.descTexts) ? _c('span', _vm._l((_vm.descTexts), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  })) : _c('span', [_vm._v("\n        " + _vm._s(_vm.descText) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57533a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DescText/DescText.vue
// module id = 753
// module chunks = 8